'use strict';

var _ = require('lodash');

/**
 * Market Analysis - Service tab - Booking Matrix
 * Flight Analysis - Service tab - Booking Matrix
 */
var BookingClassMatrixGridTransformerFactory = function BookingClassMatrixGridTransformerFactory($filter, DataTransformer, configurationService, bookingMatrixTransformationService, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function BookingClassMatrixGridTransformer() {
    this.sourceType = 'booking-matrix';
    this.targetType = ['service-demand-analysis-booking-matrix', 'service-flight-analysis-booking-matrix'];
    this.priority = 1;
  }
  function getTimeOfDaySize() {
    return configurationService.getTimeOfDayBucketSize();
  }
  function getTimeOfDayOfMoment(moment) {
    moment = moment.clone();
    var bucket = moment.hours() - moment.hours() % getTimeOfDaySize();
    return [moment.hours(bucket).minutes(0).format('HH:mm'), moment.hours(Math.min(24, bucket + getTimeOfDaySize())).minutes(0).subtract(1, 'minutes').format('HH:mm')].join('-');
  }
  BookingClassMatrixGridTransformer.prototype = Object.create(DataTransformer.prototype);
  BookingClassMatrixGridTransformer.constructor = BookingClassMatrixGridTransformer;
  BookingClassMatrixGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType.indexOf(targetType) !== -1;
  };
  BookingClassMatrixGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  BookingClassMatrixGridTransformer.prototype.getCacheKey = function (metrics, metricDescriptor) {
    var bookingMatrixMode = metricDescriptor && metricDescriptor.params ? metricDescriptor.params.bookingMatrixMode : '';
    return this.sourceType + '-' + this.targetType.join('-') + '-' + metrics.join('-') + bookingMatrixMode;
  };
  BookingClassMatrixGridTransformer.prototype.transform = function (data, metrics, metricDescriptor) {
    var bookingMatrixMode = metricDescriptor && metricDescriptor.params ? metricDescriptor.params.bookingMatrixMode : '';
    var memoizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memoizedDOWOfMoment = _.memoize(getDOWOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedTimeOfDayOfMoment = _.memoize(getTimeOfDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var transformData = function transformData(bookingMatrixData) {
      var result = [];
      if (!bookingMatrixData || !bookingMatrixData.length) {
        return;
      }
      for (var i = 0, length = bookingMatrixData.length; i < length; i++) {
        var entry = bookingMatrixData[i];
        var entryKey = entry.serviceId + entry.carrier + entry.market + entry.significantPOS + entry.departureDate;
        var momentDepartureDate = memoizedMomentOfDepartureDate(entry.departureDate, momentService.FIELD.DEPARTURE_DATE);
        var curDOW = memoizedDOWOfMoment(momentDepartureDate);
        var cabin = entry.cabin || entry.dominantCabin;
        var newEntry = {
          entryKey: entryKey,
          carrier: entry.carrier,
          cabin: cabin,
          serviceId: entry.serviceId,
          numberOfStops: entry.numberOfStops,
          //added for numberOfStops
          significantPOS: entry.significantPOS,
          market: entry.market,
          origin: entry.origin,
          destination: entry.destination,
          route: entry.route,
          posName: entry.significantPOS,
          //added for POS
          classGroup: entry.classGroup,
          className: entry.className,
          cabinIndex: configurationService.getCabinIndexMapping(entry.market)[cabin],
          classIndex: configurationService.getClassIndexMapping(entry.market)[entry.className],
          reservationHoldingsTotal: entry.reservationHoldingsTotal,
          departureDateMoment: momentDepartureDate,
          departureTimeMoment: momentDepartureDate,
          departureDateMomentDDD: curDOW,
          departureDateMomentTimeOfDay: memoizedTimeOfDayOfMoment(momentDepartureDate.value)
        };
        bookingMatrixTransformationService.transformRtpData(newEntry, entry, bookingMatrixMode);
        result.push(newEntry);
      }
      return result;
    };
    return transformData(data.domain.results);
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  function getDOWOfMoment(moment) {
    return rmMomentFormat(moment, 'DAY_OF_WEEK');
  }
  return BookingClassMatrixGridTransformer;
};
BookingClassMatrixGridTransformerFactory.$inject = ['$filter', 'DataTransformerFactory', 'ConfigurationService', 'BookingMatrixTransformationService', 'MomentService'];
module.exports = BookingClassMatrixGridTransformerFactory;